export default {
  loginButton: 'Connexion',
};
